import React from "react";

const Dudas =(props)=> {

        return (
    <div className="row justify-content-center align-items-center dudas ">
        <div className="col-12 col-md-6  dudas-box p-4">
                    <h2 className="font-weight-bold mt-4 mb-4 text-center ">¿Tiene dudas o<br/> necesita ayuda?</h2>
                    <h4 className="font-italic h4 mb-4 text-center">{props.election.configuration.support.message}</h4>
                    <div><span className="linespanblack"></span></div>
                </div>
                <div className="col-12 col-md-6 text-center h5 mt-4 font-weight-bold">
                    <p>Teléfono / {props.election.configuration.support.phone} </p><p>Email / {props.election.configuration.support.email} </p>
                </div>
            </div>

        );
    }

export default Dudas;